import React from 'react';
import { ReactComponent as Logo } from '../assets/img/Mori-Logo.svg';

function FileExLogo(props) {
    return (
        <>
            <h1 style={{ marginBottom: 30, marginTop: 20, cursor: 'pointer' }} onClick={props.clicked}><Logo alt="DMG MORI FileEx" style={{ marginRight: 10 }} />FileEx</h1>
        </>
    );
};

export default FileExLogo;